module.exports = __webpack_public_path__ + "img/gw.1da60065.png";